import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {updateCacheByType} from '../../../graphql/GraphQlProvider';
import {gqlPayment} from '../getPayment.api';
import {Payment} from '../../../graphql/payments.datatypes';

export interface CreateGroupMemberPayment {
    group_member_id: number
    amount: number
}

export interface CreatePaymentInput {
    data: {
        billing_party_member_id: number
        amount: number
        billing_party_amount: number
        timestamp: string
        payment_type: number
        payment_status: number
        provider_reference?: string | null
        provider_status?: string
        provider_response_raw?: string
        reconciled?: boolean
        description?: string
        refunds_amount?: number
        cc_fee?: number | null

        groupMembers?: {
            connect?: number[]
        }

        groupMemberPayments?: {
            create: CreateGroupMemberPayment[]
        }
    }
}

interface CreatePaymentData {
    createPayment: Payment
}

export const CREATE_PAYMENT_MUTATION = gql`
    mutation createPayment($data: CreatePaymentInput!) {
        createPayment(data: $data) {
            ${gqlPayment}
        }
    }
`;

export const createPayment = () => useMutation<CreatePaymentData, CreatePaymentInput>(
    CREATE_PAYMENT_MUTATION,
    {
        update: updateCacheByType('Payment'),
    }
);

export default createPayment;
